// extracted by mini-css-extract-plugin
export default {"form":"Qj","inline":"Rj","inputWrapper":"Sj","input":"Tj","withoutLabel":"Uj","error":"Vj","label":"Wj"};